import { Injectable } from '@angular/core';

import { EarlyPayoutAcceptance, SyncUserSettingsService } from '@frontend/sports/user/feature';
import { EarlyPayoutRequest, IEarlyPayoutParams } from 'packages/sports/web/app/src/my-bets-base/models/early-payout';
import { EarlyPayoutConst } from 'packages/sports/web/app/src/my-bets-base/models/early-payout-types';

@Injectable()
export class EarlyPayoutRequestBuilder {
    constructor(private userSettings: SyncUserSettingsService) {}

    build(params: IEarlyPayoutParams): EarlyPayoutRequest {
        if (params.earlyPayoutStake === null) {
            throw new Error('Payout stake cannot be null');
        }

        const acceptanceMode = this.getDefaultUserAcceptMode();

        return {
            bet: {
                acceptanceMode,
                betNumber: params.betslipId,
                key: 1,
                expectedPayout: params.earlyPayoutStake!,
            },
        };
    }

    private getDefaultUserAcceptMode(): EarlyPayoutConst {
        return this.userSettings.earlyPayoutAcceptance === EarlyPayoutAcceptance.Any ? EarlyPayoutConst.ModeAny : EarlyPayoutConst.ModeHigher;
    }
}
